<app-header></app-header>
<div class="acoes-resumo">
  <button type="button" class="voltar-cadastro" (click)="voltar()"><span class="mdi mdi-arrow-left" aria-hidden="true"></span> Voltar</button>
  <button type="button" class="btn btn-primary" (click)="imprimir()" [disabled]="!associado || carregando"><span class="mdi mdi-print" aria-hidden="true"></span> Imprimir cadastro</button>
</div>
<p *ngIf="carregando" class="estado-cadastro" role="status">Carregando cadastro...</p>
<p *ngIf="erro" class="alert alert-danger" role="alert">{{erro}}</p>
<main *ngIf="associado as a" class="cadastro-impressao">
  <header class="cadastro-cabecalho">
    <span class="perfil-icone mdi mdi-account" aria-hidden="true"></span>
    <div class="perfil-dados">
      <span class="sobretitulo">RESUMO DO CADASTRO</span>
      <h1>{{ a.pessoa?.nome || 'Nome não informado' }}</h1>
      <div class="perfil-etiquetas">
        <span class="etiqueta">{{a.tipo === 'AT' ? 'Ativo' : a.tipo === 'AP' ? 'Aposentado' : a.tipo === 'PE' ? 'Pensionista' : 'Tipo não informado'}}</span>
        <span class="etiqueta etiqueta-filiacao">APCF · {{a.associado_apcf == '1' ? 'Filiado' : 'Desfiliado'}}</span>
      </div>
    </div>
    <div class="filiacao-destaque"><span>Data de filiação APCF</span><strong>{{ (a.data_filiacao | date: 'dd/MM/yyyy') || 'Não informada' }}</strong></div>
  </header>
  <div class="cadastro-secoes">
    <section class="cadastro-card" aria-labelledby="titulo-identificacao">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-account-box" aria-hidden="true"></span><div><h2 id="titulo-identificacao">Identificação</h2><p>Informações pessoais do associado</p></div></div>
      <dl class="dados-cadastro">
        <div><dt>Nome</dt><dd>{{ a.pessoa?.nome || 'Não informado' }}</dd></div>
        <div><dt>CPF</dt><dd>{{ (a.pessoa_fisica?.cpf | cpf) || 'Não informado' }}</dd></div>
        <div><dt>Nascimento</dt><dd>{{ (a.pessoa_fisica?.data_nascimento | date: 'dd/MM/yyyy') || 'Não informado' }}</dd></div>
      </dl>
    </section>
    <section class="cadastro-card" aria-labelledby="titulo-filiacao">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-accounts" aria-hidden="true"></span><div><h2 id="titulo-filiacao">Filiação</h2><p>Vínculos com a associação</p></div></div>
      <dl class="dados-cadastro">
        <div><dt>Filiação APCF</dt><dd>{{a.associado_apcf == '1' ? 'Filiado' : 'Desfiliado'}}</dd></div>
        <div><dt>Data de filiação APCF</dt><dd>{{ (a.data_filiacao | date: 'dd/MM/yyyy') || 'Não informada' }}</dd></div>
        <div *ngIf="a.tipo !== 'PE'"><dt>Filiação APCF Sindical</dt><dd>{{a.associado_apcf_sindical == '1' ? 'Filiado' : 'Desfiliado'}}</dd></div>
      </dl>
    </section>
    <section class="cadastro-card" aria-labelledby="titulo-profissionais">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-case" aria-hidden="true"></span><div><h2 id="titulo-profissionais">Dados profissionais</h2><p>Identificação funcional</p></div></div>
      <dl class="dados-cadastro">
        <div><dt>Tipo de associado</dt><dd>{{a.tipo === 'AT' ? 'Ativo' : a.tipo === 'AP' ? 'Aposentado' : a.tipo === 'PE' ? 'Pensionista' : 'Não informado'}}</dd></div>
        <div><dt>Matrícula PF</dt><dd>{{ a.matricula_dpf || 'Não informado' }}</dd></div>
        <div><dt>SIAPE</dt><dd>{{ a.siape || 'Não informado' }}</dd></div>
        <div><dt>Classe</dt><dd>{{ a.classe?.nome || 'Não informado' }}</dd></div>
      </dl>
    </section>
    <section class="cadastro-card" aria-labelledby="titulo-contatos">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-phone" aria-hidden="true"></span><div><h2 id="titulo-contatos">Contatos</h2><p>Canais para falar com o associado</p></div></div>
      <dl class="dados-cadastro">
        <div><dt>E-mail</dt><dd>{{ a.pessoa?.email || 'Não informado' }}</dd></div>
        <div><dt>E-mail institucional</dt><dd>{{ a.pessoa?.email_institucional || 'Não informado' }}</dd></div>
        <div><dt>Celular</dt><dd>{{ a.pessoa?.celular_1 || 'Não informado' }}</dd></div>
        <div><dt>Telefone fixo</dt><dd>{{ a.pessoa?.telefone_fixo || 'Não informado' }}</dd></div>
      </dl>
    </section>
    <section class="cadastro-card card-amplo" aria-labelledby="titulo-endereco">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-pin" aria-hidden="true"></span><div><h2 id="titulo-endereco">Endereço</h2><p>Localização cadastrada</p></div></div>
      <dl class="dados-cadastro">
        <div><dt>Endereço</dt><dd>{{ a.pessoa?.endereco || 'Não informado' }}</dd></div>
        <div><dt>Número</dt><dd>{{ a.pessoa?.endereco_numero || 'Não informado' }}</dd></div>
        <div><dt>Complemento</dt><dd>{{ a.pessoa?.complemento || 'Não informado' }}</dd></div>
        <div><dt>Bairro</dt><dd>{{ a.pessoa?.bairro || 'Não informado' }}</dd></div>
        <div><dt>Cidade</dt><dd>{{ a.pessoa?.cidade || 'Não informado' }}</dd></div>
        <div><dt>UF</dt><dd>{{ a.pessoa?.sigla_uf || 'Não informado' }}</dd></div>
        <div><dt>CEP</dt><dd>{{ a.pessoa?.cep || 'Não informado' }}</dd></div>
      </dl>
    </section>
  </div>
</main>
<app-footer></app-footer>
